import {
  FOR_EACH_RESULT_FIELD,
  type StepOutputContract,
  StepOutputKind,
} from './stepContracts';

export interface ForEachChildResultShape {
  keys: readonly string[];
  keepsBare: boolean;
}

const BARE_KEPT_KINDS: ReadonlySet<StepOutputKind> = new Set([
  StepOutputKind.SCALAR,
  StepOutputKind.JSON_ARRAY,
]);

const KEYED_KINDS: ReadonlySet<StepOutputKind> = new Set([
  StepOutputKind.JSON_OBJECT,
  StepOutputKind.CONTEXT_KEYS,
  ...BARE_KEPT_KINDS,
]);

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const forEachChildResultShape = (
  output: StepOutputContract | undefined,
): ForEachChildResultShape | undefined => {
  if (!output?.keys?.length || !KEYED_KINDS.has(output.kind)) {
    return undefined;
  }
  return { keys: output.keys, keepsBare: BARE_KEPT_KINDS.has(output.kind) };
};

export const composeForEachChildResult = (
  output: StepOutputContract | undefined,
  bare: unknown,
  keyed: Record<string, unknown>,
): unknown => {
  const hasKeyed = Object.keys(keyed).length > 0;
  if (bare === undefined) {
    return hasKeyed ? keyed : undefined;
  }
  if (isPlainObject(bare)) {
    return hasKeyed ? { ...keyed, ...bare } : bare;
  }
  return forEachChildResultShape(output)?.keepsBare
    ? { [FOR_EACH_RESULT_FIELD.VALUE]: bare, ...keyed }
    : bare;
};
